import React, { Component } from "react";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Link } from "react-router-dom";
import Header from "../../component/common/Header";
import { getDatePartsfromTimestamp } from "../../utils";

import { getMedicalList } from "../../actions/MasterAction";
import CONSTANT from "../../constant";

export default class ListMedicals extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: undefined,
      date: new Date(),
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.allEtours;
    getMedicalList().then((res) => {
      this.setState({ list: res.result });
    });
  }

  openDetailPage = (pageUrl) => {
    this.props.history.push(pageUrl);
  };

  render() {
    const { date, list } = this.state;
    return (
      <>
        <div className="container-fluid">
          <div className="row">
            {/* <div className="col-md-2 px-0">
              <Header />
            </div> */}
            <div className="col-md-12">
              <div className="card homedob p-4 mb-4">
                <div className="row">
                  <div className="col-md-10">
                    <h1 className="page-title">
                      Medical-Rimbursment {date.getFullYear()}{" "}
                    </h1>
                  </div>
                  <div className="col-md-2 text-end">
                    <Link
                      to={CONSTANT.component.addMedicalClaim.url}
                      className="btn btn-sm submit-button"
                    >
                      <i className="fa fa-plus-circle mr-2" />
                      Apply for Medical
                    </Link>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mt-3">
                    <div className="list-container">
                      <div className="table-container">
                        <div className="table-wrapper">
                          <table className="tablen">
                            <thead>
                              <tr className="headbg">
                                <th colSpan={5} className="tabheadtitle">
                                  Files Intiated By Me
                                </th>
                              </tr>
                              <tr>
                                <th scope="col" style={{ width: "3%" }}>
                                  #
                                </th>
                                <th scope="col ">Description</th>
                                <th scope="col">Requested by</th>
                                <th scope="col">Modified</th>
                                <th scope="col">Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {list === undefined && (
                                <tr>
                                  <td colSpan={5} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              )}

                              {list !== undefined && list.length === 0 && (
                                <tr>
                                  <td colSpan={5} className="text-center">
                                    No records found
                                  </td>
                                </tr>
                              )}

                              {list !== undefined &&
                                list.map((item, index) => {
                                  const detailPageURL =
                                    CONSTANT.component.medicalClaimList.url.replace(
                                      ":code",
                                      item.id
                                    );
                                  let dated = getDatePartsfromTimestamp(
                                    item.createdOn
                                  );

                                  return (
                                    <tr
                                      key={index}
                                      className="c-pointer"
                                      onClick={() =>
                                        this.openDetailPage(detailPageURL)
                                      }
                                    >
                                      {console.log(dated)}

                                      <td>{index + 1}</td>
                                      <td
                                        className="text-truncate"
                                        style={{ maxWidth: "50px" }}
                                      >
                                        {" "}
                                        {item.description}{" "}
                                      </td>
                                      <td>{item.requestedBy}</td>
                                      <td>{`${dated.date} ${dated.month} ${dated.year} `}</td>
                                      <td>
                                        {item.status == "pending" ? (
                                          <span class="badge badge-warning w-50 p-1 ">
                                            Pending{" "}
                                          </span>
                                        ) : (
                                          <span class="badge badge-success w-50 p-1 ">
                                            Approved
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}

                              <tr>
                                <td colSpan={5} className="p-3">
                                  <div className="row">
                                    <div className="col-md-3">
                                      <button
                                        type="button"
                                        onClick={this.previousYear}
                                        className="btn btn-link btn-sm next-control"
                                      >
                                        Year {date.getFullYear() - 1}
                                      </button>
                                    </div>
                                    <div className="col-md-6"></div>
                                    <div className="col-md-3">
                                      <button
                                        type="button"
                                        onClick={this.nextYear}
                                        className="btn btn-link btn-sm float-right next-control"
                                      >
                                        Year {date.getFullYear() + 1}
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card homedob p-4 mb-4">
                <div className="row">
                  <div className="col-md-10"><h3 class="page-title">Files Intiated By Me </h3></div>
                  <div className="col-md-2 text-end">
                    <Link
                      to={CONSTANT.component.addMedicalClaim.url}
                      className="btn btn-sm submit-button"
                    >
                      <i className="fa fa-plus-circle mr-2" />
                      Apply for Medical
                    </Link>
                  </div>
                  
                </div>
                <div className="row">
                  <div className="col-md-12 mt-3">
                    <div className="list-container">
                      <div className="table-container">
                        <div className="table-wrapper">
                          <table className="tablen">
                            <thead>
                              <tr>
                                <th scope="col" style={{ width: "3%" }}>
                                  #
                                </th>
                                <th scope="col ">Description</th>
                                <th scope="col">Requested by</th>
                                <th scope="col">Modified</th>
                                <th scope="col">Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {list === undefined && (
                                <tr>
                                  <td colSpan={5} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              )}

                              {list !== undefined && list.length === 0 && (
                                <tr>
                                  <td colSpan={5} className="text-center">
                                    No records found
                                  </td>
                                </tr>
                              )}

                              {list !== undefined &&
                                list.map((item, index) => {
                                  const detailPageURL =
                                    CONSTANT.component.medicalClaimList.url.replace(
                                      ":code",
                                      item.id
                                    );
                                  let dated = getDatePartsfromTimestamp(item.createdOn);

                                  return (
                                    <tr
                                      key={index}
                                      className="c-pointer"
                                      onClick={() => this.openDetailPage(detailPageURL)}
                                    >
                                      <td>{index + 1}</td>
                                      <td
                                        className="text-truncate"
                                        style={{ maxWidth: "50px" }}
                                      >
                                        {" "}
                                        {item.description}{" "}
                                      </td>
                                      <td>{item.requestedBy}</td>
                                      <td>{`${dated.date} ${dated.month} ${dated.year} `}</td>
                                      <td>
                                        {item.status == "pending" ? (
                                          <span class="badge badge-warning w-50 p-1 ">
                                            Pending{" "}
                                          </span>
                                        ) : (
                                          <span class="badge badge-success w-50 p-1 ">
                                            Approved
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}

                              <tr>
                                <td colSpan={5} className="p-3">
                                  <div className="row">
                                    <div className="col-md-3">
                                      <button
                                        type="button"
                                        onClick={this.previousYear}
                                        className="btn btn-link btn-sm next-control"
                                      >
                                        Year {date.getFullYear() - 1}
                                      </button>
                                    </div>
                                    <div className="col-md-6"></div>
                                    <div className="col-md-3">
                                      <button
                                        type="button"
                                        onClick={this.nextYear}
                                        className="btn btn-link btn-sm float-right next-control"
                                      >
                                        Year {date.getFullYear() + 1}
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
